module.exports = __webpack_public_path__ + "static/media/notice.34b5ee20.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/notice.svg
// module id = 451
// module chunks = 3